import StudentDisabilityAPI from '@/apis/business/studentDisabilityAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('StudentDisability', StudentDisabilityAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
  },
  mutations: {
    ...crudBase.mutations,
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,
  },
}
